/*
 * The nude bra waitlist dialog, snippets/nude-waitlist.liquid. Any link to #nude-waitlist opens it:
 * the header menu's last item on desktop and in the mobile drawer, and a shared link to the shop
 * with #nude-waitlist on the end. It signs her up the way the size finder does, through Klaviyo's
 * client subscriptions API with the shop's public company id, so no key is on the page.
 */
(() => {
  const dialog = document.getElementById('nude-waitlist');
  if (!dialog) return;
  const form = dialog.querySelector('[data-nude-waitlist-form]');
  const done = dialog.querySelector('[data-nude-waitlist-done]');
  const message = dialog.querySelector('[data-nude-waitlist-message]');
  const submit = form.querySelector('[type="submit"]');
  const live = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');

  const say = (text) => {
    message.textContent = text;
    message.hidden = false;
  };

  const open = () => {
    form.hidden = false;
    done.hidden = true;
    message.hidden = true;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    form.elements.first_name.focus();
  };

  const close = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href$="#nude-waitlist"]');
    if (!link) return;
    event.preventDefault();
    // The mobile drawer stays open behind the dialog otherwise, with the page scroll locked.
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event);
    open();
  });

  dialog.addEventListener('click', (event) => {
    // A click on the backdrop lands on the dialog itself; one inside it lands on its content.
    if (event.target === dialog || event.target.closest('[data-nude-waitlist-close]')) close();
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = form.elements.email.value.trim();
    const firstName = form.elements.first_name.value.trim();
    if (!email || !form.elements.email.checkValidity()) {
      say('Please enter a valid email address.');
      form.elements.email.focus();
      return;
    }
    submit.disabled = true;
    message.hidden = true;
    try {
      // A preview theme adds nobody unless the address says it is a test, like the finder.
      if (live || /\+test/i.test(email)) {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(dialog.dataset.company)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-02-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: { type: 'profile', attributes: { email, ...(firstName ? { first_name: firstName } : {}) } },
                  },
                },
                relationships: { list: { data: { type: 'list', id: dialog.dataset.list } } },
              },
            }),
          }
        );
        if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);
      }
      form.hidden = true;
      done.hidden = false;
    } catch (error) {
      console.error('Nude waitlist sign-up failed', error);
      say('Something went wrong. Please try again.');
    } finally {
      submit.disabled = false;
    }
  });

  if (window.location.hash === '#nude-waitlist') open();
})();
